import { Badge } from 'components/ui';
import { getOrderStatusMeta } from '../utils/orderStatus';

/** Status pill for an order or order item. */
export function OrderStatusBadge({ status }) {
  const { label, tone } = getOrderStatusMeta(status);
  return <Badge tone={tone}>{label}</Badge>;
}

export default OrderStatusBadge;
